import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { ApiError } from '@/lib/api/errors'
import { updateCourt } from '@/lib/venue/courtApi'
import type { CourtListView, CourtSaveInput } from '@/lib/venue/courtTypes'

import { courtsQueryKey } from './useCourts'

/**
 * 코트 수정 (#597 §3).
 * 🚨 코트 수가 바뀌지 않으므로 구장 프로필 쿼리는 무효화하지 않는다(설계 D3).
 */
export function useUpdateCourt(venueId: string) {
  const queryClient = useQueryClient()

  return useMutation<CourtListView, ApiError, { courtId: number; input: CourtSaveInput }>({
    mutationFn: ({ courtId, input }) => updateCourt(venueId, courtId, input),
    onSuccess: (data) => {
      queryClient.setQueryData(courtsQueryKey(venueId), data)
    },
  })
}
